import PropTypes from 'prop-types';

// TODO rename keys only to Origin and Destination
export const LegType = Object.freeze({
    DEPARTURE: 'DEPARTURE',
    ARRIVAL: 'ARRIVAL',
});

export const LegTypeProps = PropTypes.oneOf(Object.values(LegType));
